import { curry } from 'ramda';

const set = curry((overlayName, element) => (element.dataset.overlayWhitelist = overlayName));
const unset = (element) => delete element.dataset.overlayWhitelist;

/**
 * This directive adds data-overlay-whitelist="arg" to the element and all its
 * children when the expression is true.
 * If an element has this attribute, the overlay ignores it when handling
 * the document click.
 * Use it for buttons that toggle overlays.
 */
export default {
  name: 'overlayWhitelist',
  shorthand(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }

    const fn = binding.value ? set(binding.arg) : unset;

    fn(el, binding.arg);

    const els = el.querySelectorAll('*');
    els.forEach((element) => {
      fn(element);
    });
  },
};
